import React from 'react';
import { Link } from 'react-router-dom';
import heroImage from '../images/narfBuilding.jpeg';

function HeroHome() {
  return (
    <section id="home" className="relative">

      {/* Illustration behind hero content */}
      <div
        className="absolute left-1/2 transform -translate-x-1/2 bottom-0 pointer-events-none -z-10"
        aria-hidden="true"
      >
        <svg
          width="1360"
          height="578"
          viewBox="0 0 1360 578"
          xmlns="http://www.w3.org/2000/svg"
        >
          <defs>
            <linearGradient x1="0%" x2="100%" y1="0%" y2="100%" id="illustration-01">
              <stop stopColor="#FFF" offset="0%" />
              <stop stopColor="#a3ccd2" offset="65%" />
              <stop stopColor="#8cc0c7" offset="90%" />
              <stop stopColor="#5ea6b0" offset="90%" />
              <stop stopColor="#19818e" offset="100%" />
            </linearGradient>
          </defs>
          <g fill="url(#illustration-01)" fillRule="evenodd">
            <circle cx="1232" cy="128" r="128" />
            <circle cx="155" cy="443" r="64" />
          </g>
        </svg>
      </div>

      <div className="max-w-6xl mx-auto px-4 sm:px-6">
        <div className="pt-32 pb-12 md:pt-24 md:pb-20">

          {/* Hero Image */}
          <div className="relative flex justify-center mb-8" data-aos="zoom-y-out" data-aos-delay="450">
            <div className="flex flex-col justify-center">
              <img
                className="mx-auto rounded-lg shadow-lg"
                src={heroImage}
                width="700"
                alt="Northern Arizona Rehabilitation and Fitness Building"
              />
            </div>

            <a
              className="absolute top-full flex items-center transform -translate-y-1/2 rounded-full font-medium group p-4 shadow-lg bg-gradient-to-t from-teal-5 to-white hover:text-teal-50"
              href="#features-blocks"
            >
              <span className="ml-6 mr-6">Our Services</span>
            </a>
          </div>

          {/* Section Header */}
          <div className="text-center pb-12 md:pb-16 md:pt-10">
            <h1
              className="text-2xl md:text-3xl font-bold italic leading-tighter tracking-tighter mb-4"
              data-aos="zoom-y-out"
            >
              Empowering Our Community One Person At A Time.
            </h1>

            <h1 className="text-4xl md:text-5xl font-bold leading-tighter tracking-tighter mb-4 bg-clip-text text-transparent bg-gradient-to-r from-teal-50 to-yellow-50">
              Northern Arizona Rehabilitation and Fitness
            </h1>

            <div className="max-w-3xl mx-auto">
              <p
                className="text-xl text-gray-600 mb-8"
                data-aos="zoom-y-out"
                data-aos-delay="150"
              >
                To promote, enhance, and facilitate the quality of life and the recovery
                of normal movement for our patients through skilled therapeutic intervention.
              </p>

              <div
                className="max-w-xs mx-auto sm:max-w-none sm:flex sm:justify-center"
                data-aos="zoom-y-out"
                data-aos-delay="300"
              >
                <Link
                  to="/contact-us"
                  className="btn text-white bg-teal-50 hover:bg-yellow-50 w-full mb-4 sm:w-auto sm:mb-0"
                >
                  Schedule Appointment
                </Link>
              </div>
            </div>
          </div>

        </div>
      </div>
    </section>
  );
}

export default HeroHome;